import { Component, OnInit } from '@angular/core';
import { Partner } from '../../../models/partner';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-partner-detail-header',
  templateUrl: './partner-detail-header.component.html',
  styleUrls: ['./partner-detail-header.component.scss']
})
export class PartnerDetailHeaderComponent implements OnInit {

  partner: Partner;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {

    //track selected partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;
    })
  }

}
